import { commonThinxHeaders, deleteJson, get, jsonGet, jsonPost, jsonPut } from 'api'

export const getSubscriptionHistory = (accountKey, token) =>
    jsonGet(
        `${window.THINX_BASE_SUBSCRIPTIONS_URL}/subscription/account/${accountKey}`,
        {
            includeMembers: true,
        },
        commonThinxHeaders(token, true)
    ).catch(error => {
        throw new Error(error.message)
    })

export const getOneSubscription = (subscriptionId, token) =>
    jsonGet(
        `${window.THINX_BASE_SUBSCRIPTIONS_URL}/subscription/${subscriptionId}`,
        {
            includeMembers: true,
        },
        commonThinxHeaders(token, true)
    ).catch(error => {
        throw new Error(error.message)
    })

export const getSubscriptionBalance = (zaccountId, token) =>
    jsonGet(
        `${window.THINX_BASE_SUBSCRIPTIONS_PORTAL_URL}/subscription/metrics`,
        {
            zaccountId,
        },
        commonThinxHeaders(token, true)
    ).catch(error => {
        throw new Error(error.message)
    })

export const updateSubscription = (token, data) =>
    jsonPost(`${window.THINX_BASE_SUBSCRIPTIONS_URL}/subscription/save/`, data, commonThinxHeaders(token)).catch(
        error => {
            throw new Error(error.message)
        }
    )

export const getSubscriptionInvoices = (subscriptionId, token) =>
    jsonGet(
        `${window.THINX_BASE_SUBSCRIPTIONS_PORTAL_URL}/subscription/invoices/${subscriptionId}`,
        null,
        commonThinxHeaders(token, true)
    ).catch(error => {
        throw new Error(error.message)
    })

export const getSubscriptionReceipts = (subscriptionId, token) =>
    jsonGet(
        `${window.THINX_BASE_SUBSCRIPITONS_RECEIPT_URL}/items/${subscriptionId}`,
        null,
        commonThinxHeaders(token, true)
    ).catch(error => {
        throw new Error(error.message)
    })

export const payInvoice = (token, data) =>
    jsonPost(
        `${window.THINX_BASE_SUBSCRIPTIONS_PORTAL_URL}/subscription/payment/invoice`,
        data,
        commonThinxHeaders(token)
    ).catch(error => {
        throw new Error(error.message)
    })

export const downloadInvoice = (invoiceId, token) =>
    get(
        `${window.THINX_BASE_SUBSCRIPITONS_FILES_URL}/invoice/${invoiceId}`,
        null,
        commonThinxHeaders(token, true, { Accept: 'application/pdf' })
    )
        .then(async res => await res.blob())
        .catch(error => {
            throw new Error(error.message)
        })

export const downloadReceipt = (subscriptionId, paymentNumber, lang, token) =>
    get(
        `${window.THINX_BASE_SUBSCRIPITONS_FILES_URL}/receipt/${paymentNumber}?subId=${subscriptionId}&requestedLanguage=${lang}`,
        null,
        commonThinxHeaders(token, true, { Accept: 'application/pdf' })
    )
        .then(async res => await res.blob())
        .catch(error => {
            throw new Error(error.message)
        })

export const assignParker = (data, token, subscriptionId, selfService) =>
    jsonPut(
        `${window.THINX_BASE_SUBSCRIPTIONS_PORTAL_URL}/parker/update/${subscriptionId}?selfService=${selfService}`,
        undefined,
        { ...data },
        commonThinxHeaders(token, true)
    ).catch(error => {
        throw new Error(error.message)
    })

export const getWaitList = (accountKey, token) =>
    jsonGet(`${window.THINX_BASE_WAITLIST_URL}/request/account/${accountKey}`, null, commonThinxHeaders(token, true))

export const getWaitListItem = (waitListId, token) =>
    jsonGet(`${window.THINX_BASE_WAITLIST_URL}/${waitListId}`, null, commonThinxHeaders(token, true))

export const deleteWaitListItem = (waitListId, token, locale) =>
    deleteJson(
        `${window.THINX_BASE_WAITLIST_URL}/cancel/${waitListId}?locale=${locale}`,
        null,
        commonThinxHeaders(token, true)
    )
